import { AfterContentInit, ContentChild, Directive, Input, OnDestroy } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { Observable, Subscription } from 'rxjs';
import { MojoBatchService } from 'mojo-batch';
@Directive({
  selector: '[mojoBatchItemSelector]',
  exportAs: 'mojoBatchItemSelector',
})
export class BatchItemSelectorDirective implements AfterContentInit, OnDestroy {
  /** provide identifier for selected item */
  @Input() mojoBatchItemSelector;

  /** select checkbox controler for controling selection state */
  @ContentChild('batchItemSelectorCheckbox') checkbox: MatCheckbox;

  private subscription: Subscription;

  constructor(private readonly batchSelectionManager: MojoBatchService) {}

  /** public api for getting selection state */
  get isSelected$(): Observable<boolean> {
    return this.batchSelectionManager.getItemSelectionStatus$(this.mojoBatchItemSelector);
  }

  ngAfterContentInit(): void {
    this.isSelected$.subscribe((isSelected) => {
      this.checkbox.checked = isSelected;
    });

    this.subscription = this.checkbox.change.subscribe(({ checked }) => {
      this.batchSelectionManager.setItemSelectionStatus(this.mojoBatchItemSelector, checked);
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
